import Grid from "@mui/material/Grid2";
import MaterialUiButton from '../../Buttons/MaterialUiButton/MaterialUiButton';
import ModalDialog from '../ModalDialog/ModalDialog'

function CreEditModal(props) {
  const {
    fields,
    handleCreateSubmit,
    handleEditSubmit,
    modalOpen,
    modalType,
    setModalOpen,
    title,
  } = props
  const content = (
    <>
      <Grid container spacing={2} size={12}>
        {fields}
      </Grid>
      <Grid sx={{
        display: "flex",
        justifyContent: "space-between",
        paddingTop: "20px",
      }}
      >
        {/* Cancel Button */}
        <Grid size={4}>
          <MaterialUiButton
            color="cancel"
            // cypressId={cypressIds.cancel + "-btn-cancel"}
            fullWidth
            label="Cancel"
            onClick={() => {
              setModalOpen(false);
            }}
            variant="outlined"
          />
        </Grid>

        {/* Submit Button */}
        <Grid size={4}>
          <MaterialUiButton
            color="submit"
            // cypressId={cypressIds.create + "-btn-submit"}
            fullWidth
            label="Submit"
            onClick={() => {
              if (modalType === "Create") {
                handleCreateSubmit();
              } else {
                handleEditSubmit();
              }
            }}
            variant="contained"
          />
        </Grid>
      </Grid>
    </>
  )

  return (
    <ModalDialog
      content={content}
      handleClose={() => {
        setModalOpen(false);
      }}
      hasFormFields={true}
      open={modalOpen}
      title={`${modalType} ${title}`}
    />
  )
}

export default CreEditModal